import { makeAutoObservable } from "mobx";
import * as RatingProvider from '../../services/rating';
import { RatingAdmResponse } from '../../services/rating';
import * as PubSub from '../pubSub';
import { Manager } from "../../core";

export class RatingStoreMobx {
	public list: RatingAdmResponse[] = [];
	constructor() {
		makeAutoObservable(this);
	}

	get = async () => {
		try {
			const { data }: any = await RatingProvider.getRatings();
			this.setRatingList(data || []);
			return data;
		} catch (err) {
			throw new Manager.ServiceError('error.ratingStore.get', err);
		}
	}

	getAverageRate = (): string => {
		if (!this.list || this.list.length === 0) return '0.0';
		const sum = this.list.reduce((acc, r) => acc + (r.rate || 0), 0);
		return (sum / this.list.length).toFixed(1);
	}

	setRatingList = (list: RatingAdmResponse[]) => {
		this.list = list;
	}

	getRatingByComboId = (comboId: number): RatingAdmResponse | undefined => {
		return this.list.find(r => Number(r.comboId) === Number(comboId));
	}

	getRatingsByComboId = (comboId: number): RatingAdmResponse[] => {
		return this.list.filter(r => Number(r.comboId) === Number(comboId));
	}
}

let singleton: RatingStoreMobx | null;

export const RatingStore = () => {
	if (!singleton) {
		singleton = new RatingStoreMobx();

		PubSub.subscribe(PubSub.LOGOUT, () => {
			singleton = null;
		});
	}
	return singleton;
};
